import { render, staticRenderFns } from "./FiscalContact.vue?vue&type=template&id=be671ac2&scoped=true"
import script from "./FiscalContact.vue?vue&type=script&lang=js"
export * from "./FiscalContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be671ac2",
  null
  
)

export default component.exports